import React, { Component } from 'react';
import check from '../../Images/Icons/check.png';
import { getIcon } from '../Common/Common';
import chmaster from '../../Images/Cell_Status_Icon/CHmaster/chmaster.png';

export default class Management_Point_Selection_Cell extends Component {
	constructor(props) {
		super(props);
		this.state = {
			is_cell_selected: false,
		}
	}

	toggleSelected = () => {
		if (!this.props.is_disabled) {
			this.setState({ is_cell_selected: !this.state.is_cell_selected });
			this.props.handleSetToggle(this.props.id)
		}
	}

	render() {
		let style = {
			display: 'inline-block',
			verticalAlign: 'top',
			width: this.props.width - 20,
			textAlign: 'left',
		}

		let cell_style = {
			margin: '5px 10px',
			padding: 10,
			backgroundColor: this.props.is_disabled ? '#c3c3c3' : 'white',
			opacity: this.props.is_disabled ? 0.3 : 1,
			borderRadius: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
		}

		style = Object.assign(style, this.props.style);
		cell_style = Object.assign(cell_style, this.props.cell_style);
		let icon = getIcon(this.props.point_info.icon, this.props.point_info.stat);

		return (
			<div style={style} id={this.props.id + '_cell_external'}>
				<div id={this.props.id + '_cell_internal'} style={cell_style}  >
					<div onClick={this.toggleSelected} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
						<div style={{ width: 25, display: this.props.is_selected ? 'inline-block' : 'none' }}>
							<img src={check} style={{ width: 25 }} />
						</div>
						<div style={{ display: 'inline-block', marginLeft: this.props.is_selected ? 10 : 35, }}>
							<img src={icon} style={{ width: 25 }} />
							<div style={{ display: this.props.point_info.ch_master ? 'block' : 'none', position: 'relative' }}>
								<img src={chmaster} style={{ width: 15, position: 'absolute', top: -10, left: 15 }} />
							</div>
						</div>
						<div style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 10 }} >
							<span id={this.props.id + '_cell_span'} style={{}}>{this.props.point_info.name}</span>
						</div>
					</div>
					{this.props.children}
				</div>

			</div>
		)
	}
}